export default "__VITE_ASSET__DDbauCao__"